// runtime can't be in strict mode because a global variable is assign and maybe created.
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6158],{

/***/ 23199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E$": function() { return /* binding */ clearInviteCode; },
/* harmony export */   "LP": function() { return /* binding */ getToken; },
/* harmony export */   "o4": function() { return /* binding */ setToken; },
/* harmony export */   "pQ": function() { return /* binding */ deleteToken; }
/* harmony export */ });
/* unused harmony export checkLogin */
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42586);


function checkLogin() {
  return !!getToken();
}
function getToken() {
  return (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)(_constants__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_COOKIE */ .Md);
}
function deleteToken() {
  (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.deleteCookie)(_constants__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_COOKIE */ .Md);
  localStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_COOKIE */ .Md);
}
function setToken() {
  let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.setCookie)(_constants__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_COOKIE */ .Md, value, {
    maxAge: _constants__WEBPACK_IMPORTED_MODULE_1__/* .COOKIE_EXPIRE_TIME */ .pn
  });
  localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_COOKIE */ .Md, value);
}
function clearInviteCode() {
  localStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_1__/* .INVITE_CODE_STORAGE */ .zX);
}

/***/ }),

/***/ 42586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BQ": function() { return /* binding */ LIVE_URL; },
/* harmony export */   "BT": function() { return /* binding */ UNAUTHORIZED_CODE; },
/* harmony export */   "Gh": function() { return /* binding */ SUCCESS_CODE; },
/* harmony export */   "Gi": function() { return /* binding */ PERMISSION_DENIED_CODE; },
/* harmony export */   "HH": function() { return /* binding */ BLUR_CODE; },
/* harmony export */   "LX": function() { return /* binding */ VERSION_STORAGE_VALID_KEY_PREFIX; },
/* harmony export */   "LZ": function() { return /* binding */ SHOW_TRIAL_MODAL; },
/* harmony export */   "MC": function() { return /* binding */ NOT_VERIFIED; },
/* harmony export */   "Md": function() { return /* binding */ TOKEN_COOKIE; },
/* harmony export */   "N1": function() { return /* binding */ TIKTOK_SHOP_OCCUPIED_CODE; },
/* harmony export */   "N5": function() { return /* binding */ PHONE_VERIFY_STORAGE_KEY; },
/* harmony export */   "QK": function() { return /* binding */ MULTIPLE_LOGIN_CODE; },
/* harmony export */   "SM": function() { return /* binding */ CURRENCY_COOKIE; },
/* harmony export */   "Sr": function() { return /* binding */ TIKTOK_SHOP_FAILED_CODE; },
/* harmony export */   "Yk": function() { return /* binding */ LANG_COOKIE; },
/* harmony export */   "Zg": function() { return /* binding */ BLUR_VALUE; },
/* harmony export */   "_w": function() { return /* binding */ TIKTOK_SHOP_UNAUTHORIZED_CODE; },
/* harmony export */   "bX": function() { return /* binding */ QUOTA_LACKING; },
/* harmony export */   "ch": function() { return /* binding */ LOCAL_USERINFO_KEY; },
/* harmony export */   "f9": function() { return /* binding */ BLUR_VALUE_2; },
/* harmony export */   "fJ": function() { return /* binding */ IS_FIRST_VISIT_COOKIE; },
/* harmony export */   "gw": function() { return /* binding */ TENCENT_APPID; },
/* harmony export */   "jO": function() { return /* binding */ REGION_COOKIE; },
/* harmony export */   "o9": function() { return /* binding */ ECHO_VERSION; },
/* harmony export */   "pn": function() { return /* binding */ COOKIE_EXPIRE_TIME; },
/* harmony export */   "rZ": function() { return /* binding */ VERSION_STORAGE_KEY_PREFIX; },
/* harmony export */   "rx": function() { return /* binding */ RECHARGE_STORAGE_KEY; },
/* harmony export */   "tr": function() { return /* binding */ BLUR_COVER; },
/* harmony export */   "wL": function() { return /* binding */ GOOGLE_CLIENT_ID; },
/* harmony export */   "yL": function() { return /* binding */ TIKTOK_SHOP_EXPIRED_CODE; },
/* harmony export */   "zX": function() { return /* binding */ INVITE_CODE_STORAGE; }
/* harmony export */ });
/* unused harmony exports REGISTER_CONTINUE_CODE, NOTIFY_ID, GO_URL, REACT_APP_SITE_KEY, NEXT_PUBLIC_POSTHOG_KEY, NEXT_PUBLIC_POSTHOG_HOST */
const VERSION_STORAGE_KEY_PREFIX = 'echo_version_data';
const VERSION_STORAGE_VALID_KEY_PREFIX = 'echo_version_valid';
const ECHO_VERSION = 'ECHO_VERSION'; // 注册时，继续填写信息

const REGISTER_CONTINUE_CODE = 20004; // 表示该值需要模糊

const BLUR_VALUE = 'N/A';
const BLUR_VALUE_2 = '***';
const BLUR_CODE = 100004;
const BLUR_COVER = '888'; // 接口成功的业务状态码，

const SUCCESS_CODE = 0; // 会员权限不足

const UNAUTHORIZED_CODE = 50001; // 用户没有权限访问

const PERMISSION_DENIED_CODE = 10007; // 多人登录错误码

const MULTIPLE_LOGIN_CODE = 10011;
const TOKEN_COOKIE = 'token';
const LANG_COOKIE = 'lang';
const CURRENCY_COOKIE = 'currency';
const REGION_COOKIE = 'region';
const IS_FIRST_VISIT_COOKIE = 'is_first_visit'; // COOKIE过期时间30天

const COOKIE_EXPIRE_TIME = 60 * 60 * 24 * 30;
const GOOGLE_CLIENT_ID = '375243906986-3s8cn8072mu25h7su3lnp3m3uj0sjo46.apps.googleusercontent.com';
const NOTIFY_ID = 'notify_id';
const INVITE_CODE_STORAGE = 'invite_code';
const SHOW_TRIAL_MODAL = 'show_trial_modal';
const NOT_VERIFIED = 20001; // 配额不足

const QUOTA_LACKING = 40001; // 店铺已被绑定其他账号

const TIKTOK_SHOP_OCCUPIED_CODE = 30006; // 授权回调失败

const TIKTOK_SHOP_FAILED_CODE = 30007; // 店铺未授权

const TIKTOK_SHOP_UNAUTHORIZED_CODE = 30008; // 店铺授权过期

const TIKTOK_SHOP_EXPIRED_CODE = 30009; // 首页直播banner

const LIVE_URL = `https://d18sdvl5kwtzlk.cloudfront.net/misc/echotik-banner-1.webp`; // banner跳转链接

const GO_URL = 'https://mp.weixin.qq.com/s/9P9gIi1YI3guloUJzTcKRQ';
const REACT_APP_SITE_KEY = '6LftD-MoAAAAAPpJcFy7Os_TBJMZbRZtgFO4Sd2G';
const LOCAL_USERINFO_KEY = 'userInfo'; // 绑定手机号提醒

const PHONE_VERIFY_STORAGE_KEY = 'phone_verify_modal_key';
const NEXT_PUBLIC_POSTHOG_KEY = 'phc_sYMtIBI4VtZqhAer3R1qAfXCIloFQXBy8DeLlEHSiOb';
const NEXT_PUBLIC_POSTHOG_HOST = 'https://us.i.posthog.com';
const TENCENT_APPID = '197160336'; // 续费弹窗提醒

const RECHARGE_STORAGE_KEY = 'recharge_modal_key';

/***/ }),

/***/ 39533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ setCookieWithMaxAge; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42586);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_1__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



const setCookieWithMaxAge = function (key, data) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0,cookies_next__WEBPACK_IMPORTED_MODULE_1__.setCookie)(key, data, _objectSpread({
    maxAge: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIE_EXPIRE_TIME */ .pn
  }, options));
};

/***/ }),

/***/ 88028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Currency; },
/* harmony export */   "S": function() { return /* binding */ isValidCurrency; }
/* harmony export */ });
// 货币
let Currency;

(function (Currency) {
  Currency["ID"] = "IDR";
  Currency["MY"] = "MYR";
  Currency["PH"] = "PHP";
  Currency["TH"] = "THB";
  Currency["VN"] = "VND";
  Currency["SG"] = "SGD";
  Currency["GB"] = "GBP";
  Currency["US"] = "USD";
  Currency["ES"] = "EUR";
  Currency["MX"] = "MXN";
  Currency["DE"] = "EUR";
  Currency["IT"] = "EUR";
  Currency["FR"] = "EUR";
  Currency["GLOBAL"] = "USD";
})(Currency || (Currency = {}));

function isValidCurrency(currency) {
  if (currency === undefined) {
    return false;
  }

  return [Currency.ID, Currency.MY, Currency.PH, Currency.TH, Currency.VN, Currency.SG, Currency.GB, Currency.US, Currency.GLOBAL, Currency.ES, Currency.MX, Currency.DE, Currency.IT, Currency.FR].includes(currency);
}

/***/ }),

/***/ 73529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ fbCompleteRegistrationEvent; },
/* harmony export */   "v": function() { return /* binding */ fbInitiateCheckoutEvent; }
/* harmony export */ });
/* harmony import */ var _hooks_useBdVid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63128);
 // 点击弹窗中的立即购买按钮, 开始结账流程。例如，点击“结账”按钮。

const fbInitiateCheckoutEvent = () => {
  var _window, _window$fbq;

  const {
    promotion_type,
    promotion_id
  } = (0,_hooks_useBdVid__WEBPACK_IMPORTED_MODULE_0__/* .getPromotionInfo */ .yG)();
  (_window = window) === null || _window === void 0 ? void 0 : (_window$fbq = _window.fbq) === null || _window$fbq === void 0 ? void 0 : _window$fbq.call(_window, 'track', 'InitiateCheckout', {
    promotion_type,
    promotion_id
  });
}; // 用户完成注册。

const fbCompleteRegistrationEvent = () => {
  var _window2, _window2$fbq;

  const {
    promotion_type,
    promotion_id
  } = (0,_hooks_useBdVid__WEBPACK_IMPORTED_MODULE_0__/* .getPromotionInfo */ .yG)();
  (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$fbq = _window2.fbq) === null || _window2$fbq === void 0 ? void 0 : _window2$fbq.call(_window2, 'track', 'CompleteRegistration', {
    promotion_type,
    promotion_id
  });
};

/***/ }),

/***/ 77932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_language__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39080);
/* harmony import */ var _utils_currency__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88028);
/* harmony import */ var _utils_region__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37101);




const generateCookies = async _ref => {
  let {
    acceptLanguage = '',
    languageFromCookie = '',
    currencyFromCookie = '',
    regionFromCookie = '',
    token = ''
  } = _ref;
  const defaultLanguage = acceptLanguage.startsWith(_utils_language__WEBPACK_IMPORTED_MODULE_0__/* .Language.zhCN */ .S.zhCN) ? _utils_language__WEBPACK_IMPORTED_MODULE_0__/* .Language.zhCN */ .S.zhCN : _utils_language__WEBPACK_IMPORTED_MODULE_0__/* .Language.enUS */ .S.enUS;
  const language = (0,_utils_language__WEBPACK_IMPORTED_MODULE_0__/* .isValidLanguage */ .D)(languageFromCookie) ? languageFromCookie : defaultLanguage;
  const currency = (0,_utils_currency__WEBPACK_IMPORTED_MODULE_1__/* .isValidCurrency */ .S)(currencyFromCookie) ? currencyFromCookie : _utils_currency__WEBPACK_IMPORTED_MODULE_1__/* .Currency.US */ .F.US;
  const region = (0,_utils_region__WEBPACK_IMPORTED_MODULE_2__/* .isValidRegion */ .U)(regionFromCookie) ? regionFromCookie : _utils_region__WEBPACK_IMPORTED_MODULE_2__/* .Region.US */ .y.US;
  return {
    language,
    currency,
    region
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (generateCookies);

/***/ }),

/***/ 1405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kn": function() { return /* binding */ isObject; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; },
/* harmony export */   "r7": function() { return /* binding */ isBlurValue; },
/* harmony export */   "tq": function() { return /* binding */ isMobile; },
/* harmony export */   "xb": function() { return /* binding */ isEmpty; },
/* harmony export */   "yF": function() { return /* binding */ isSSR; }
/* harmony export */ });
/* unused harmony exports isArray, isString, isTablet, checkImageUrl */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42586);

function isArray(val) {
  return Object.prototype.toString.call(val) === '[object Array]';
}
function isObject(val) {
  return Object.prototype.toString.call(val) === '[object Object]';
}
function isString(val) {
  return Object.prototype.toString.call(val) === '[object String]';
}
const isSSR = function () {
  try {
    return !( true && document !== undefined);
  } catch (e) {
    return true;
  }
}();
const isEmpty = data => {
  if (['', undefined, null].includes(data)) {
    return true;
  }

  if (Array.isArray(data) && data.length === 0) {
    return true;
  }

  if (JSON.stringify(data) === '{}') {
    return true;
  }

  return false;
};
function isTablet(ua) {
  const userAgent = ua.toLowerCase(); // 判断是否是 iPad

  if (userAgent.indexOf('ipad') !== -1) {
    return true;
  } // 判断是否是 Android 平板


  if (userAgent.indexOf('android') !== -1 && userAgent.indexOf('mobile') === -1) {
    return true;
  }

  return false;
}
const isMobile = ua => {
  if (!ua) return false;

  if (isTablet(ua)) {
    return false;
  }

  if (ua.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    return true;
  }

  return false;
};
const isNumber = val => {
  return Number.isFinite(val);
};
const checkImageUrl = val => {
  if (typeof val !== 'string') return '';
  const urlRegex = /^(https?:\/\/)/;
  const pathRegex = /^\/.*/;

  if (urlRegex.test(val) || pathRegex.test(val)) {
    return val;
  }

  return '';
};
const isBlurValue = val => {
  return val === _constants__WEBPACK_IMPORTED_MODULE_0__/* .BLUR_VALUE */ .Zg || val === _constants__WEBPACK_IMPORTED_MODULE_0__/* .BLUR_VALUE_2 */ .f9;
};

/***/ }),

/***/ 39080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ isValidLanguage; },
/* harmony export */   "S": function() { return /* binding */ Language; }
/* harmony export */ });
let Language;

(function (Language) {
  Language["zhCN"] = "zh-CN";
  Language["enUS"] = "en-US";
  Language["idID"] = "id-ID";
  Language["thTH"] = "th-TH";
  Language["msMY"] = "ms-MY";
  Language["esES"] = "es-ES";
})(Language || (Language = {}));

function isValidLanguage(lang) {
  if (!lang) {
    return false;
  }

  return [Language.enUS, Language.zhCN, Language.idID, Language.thTH, Language.msMY, Language.esES].includes(lang);
}

/***/ }),

/***/ 37101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ isValidRegion; },
/* harmony export */   "y": function() { return /* binding */ Region; }
/* harmony export */ });
// 地区
let Region;

(function (Region) {
  Region["ID"] = "ID";
  Region["MY"] = "MY";
  Region["PH"] = "PH";
  Region["TH"] = "TH";
  Region["VN"] = "VN";
  Region["SG"] = "SG";
  Region["GB"] = "GB";
  Region["US"] = "US";
  Region["ES"] = "ES";
  Region["MX"] = "MX";
  Region["DE"] = "DE";
  Region["IT"] = "IT";
  Region["FR"] = "FR";
  Region["GLOBAL"] = "";
})(Region || (Region = {}));

function isValidRegion(region) {
  if (region === undefined) {
    return false;
  }

  return [Region.ID, Region.MY, Region.PH, Region.TH, Region.VN, Region.SG, Region.GB, Region.US, Region.GLOBAL, Region.ES, Region.MX, Region.DE, Region.IT, Region.FR].includes(region);
}

/***/ }),

/***/ 37131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _assets_flags_GB_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87393);
/* harmony import */ var _assets_flags_ID_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83122);
/* harmony import */ var _assets_flags_MY_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93817);
/* harmony import */ var _assets_flags_PH_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48588);
/* harmony import */ var _assets_flags_SG_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84539);
/* harmony import */ var _assets_flags_TH_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1997);
/* harmony import */ var _assets_flags_US_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22093);
/* harmony import */ var _assets_flags_VN_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82135);
/* harmony import */ var _assets_flags_IT_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51414);
/* harmony import */ var _assets_flags_TR_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66588);
/* harmony import */ var _assets_flags_CN_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28750);
/* harmony import */ var _assets_flags_AR_svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47939);
/* harmony import */ var _assets_flags_globe_svg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85105);
/* harmony import */ var _assets_flags_BR_svg__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(94576);
/* harmony import */ var _assets_flags_KR_svg__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(20499);
/* harmony import */ var _assets_flags_QA_svg__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(23948);
/* harmony import */ var _assets_flags_AD_svg__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(23179);
/* harmony import */ var _assets_flags_AE_svg__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(12782);
/* harmony import */ var _assets_flags_AF_svg__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(43913);
/* harmony import */ var _assets_flags_AG_svg__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(63478);
/* harmony import */ var _assets_flags_AL_svg__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(87436);
/* harmony import */ var _assets_flags_AM_svg__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(43845);
/* harmony import */ var _assets_flags_AO_svg__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(11557);
/* harmony import */ var _assets_flags_AT_svg__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(57604);
/* harmony import */ var _assets_flags_AU_svg__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(46664);
/* harmony import */ var _assets_flags_AZ_svg__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(77518);
/* harmony import */ var _assets_flags_BA_svg__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(92960);
/* harmony import */ var _assets_flags_BB_svg__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(69550);
/* harmony import */ var _assets_flags_BD_svg__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(31594);
/* harmony import */ var _assets_flags_BE_svg__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(93717);
/* harmony import */ var _assets_flags_BF_svg__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(85460);
/* harmony import */ var _assets_flags_BG_svg__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(29790);
/* harmony import */ var _assets_flags_BH_svg__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(98870);
/* harmony import */ var _assets_flags_BI_svg__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(25745);
/* harmony import */ var _assets_flags_BJ_svg__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(61882);
/* harmony import */ var _assets_flags_BN_svg__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(26532);
/* harmony import */ var _assets_flags_BO_svg__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(47415);
/* harmony import */ var _assets_flags_BS_svg__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(29610);
/* harmony import */ var _assets_flags_BT_svg__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(78698);
/* harmony import */ var _assets_flags_BW_svg__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(40224);
/* harmony import */ var _assets_flags_BY_svg__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(59658);
/* harmony import */ var _assets_flags_BZ_svg__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(67649);
/* harmony import */ var _assets_flags_CA_svg__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(91619);
/* harmony import */ var _assets_flags_CD_svg__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(48744);
/* harmony import */ var _assets_flags_CF_svg__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(90689);
/* harmony import */ var _assets_flags_CG_svg__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(21715);
/* harmony import */ var _assets_flags_CH_svg__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(2848);
/* harmony import */ var _assets_flags_CI_svg__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(58056);
/* harmony import */ var _assets_flags_CL_svg__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(4482);
/* harmony import */ var _assets_flags_CM_svg__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(90292);
/* harmony import */ var _assets_flags_CO_svg__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(38386);
/* harmony import */ var _assets_flags_CR_svg__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(41121);
/* harmony import */ var _assets_flags_CU_svg__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(77193);
/* harmony import */ var _assets_flags_CV_svg__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(30196);
/* harmony import */ var _assets_flags_CY_svg__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(84655);
/* harmony import */ var _assets_flags_CZ_svg__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(93489);
/* harmony import */ var _assets_flags_DE_svg__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(11195);
/* harmony import */ var _assets_flags_DJ_svg__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(59722);
/* harmony import */ var _assets_flags_DK_svg__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(6405);
/* harmony import */ var _assets_flags_DM_svg__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(33177);
/* harmony import */ var _assets_flags_DO_svg__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(5225);
/* harmony import */ var _assets_flags_DZ_svg__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(86081);
/* harmony import */ var _assets_flags_EC_svg__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(85790);
/* harmony import */ var _assets_flags_EE_svg__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(59109);
/* harmony import */ var _assets_flags_EG_svg__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(36793);
/* harmony import */ var _assets_flags_ER_svg__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(32334);
/* harmony import */ var _assets_flags_ES_svg__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(63074);
/* harmony import */ var _assets_flags_ET_svg__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(98577);
/* harmony import */ var _assets_flags_FI_svg__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(91734);
/* harmony import */ var _assets_flags_FJ_svg__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(57820);
/* harmony import */ var _assets_flags_FM_svg__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(47460);
/* harmony import */ var _assets_flags_FR_svg__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(34603);
/* harmony import */ var _assets_flags_GA_svg__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(34759);
/* harmony import */ var _assets_flags_GD_svg__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(71165);
/* harmony import */ var _assets_flags_GE_svg__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(27341);
/* harmony import */ var _assets_flags_GH_svg__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(45571);
/* harmony import */ var _assets_flags_GM_svg__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(81984);
/* harmony import */ var _assets_flags_GN_svg__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(71814);
/* harmony import */ var _assets_flags_GQ_svg__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(51862);
/* harmony import */ var _assets_flags_GR_svg__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(55711);
/* harmony import */ var _assets_flags_GT_svg__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(34701);
/* harmony import */ var _assets_flags_GW_svg__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(89776);
/* harmony import */ var _assets_flags_GY_svg__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(18012);
/* harmony import */ var _assets_flags_HK_svg__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(83765);
/* harmony import */ var _assets_flags_HN_svg__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(4605);
/* harmony import */ var _assets_flags_HR_svg__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(15800);
/* harmony import */ var _assets_flags_HT_svg__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(34059);
/* harmony import */ var _assets_flags_HU_svg__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(75629);
/* harmony import */ var _assets_flags_IE_svg__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(8922);
/* harmony import */ var _assets_flags_IL_svg__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(58625);
/* harmony import */ var _assets_flags_IN_svg__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(44863);
/* harmony import */ var _assets_flags_IQ_svg__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(10764);
/* harmony import */ var _assets_flags_IR_svg__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(22230);
/* harmony import */ var _assets_flags_IS_svg__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(97142);
/* harmony import */ var _assets_flags_JM_svg__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(81592);
/* harmony import */ var _assets_flags_JO_svg__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(43156);
/* harmony import */ var _assets_flags_JP_svg__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(29425);
/* harmony import */ var _assets_flags_KE_svg__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(43355);
/* harmony import */ var _assets_flags_KG_svg__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(76548);
/* harmony import */ var _assets_flags_KH_svg__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(73224);
/* harmony import */ var _assets_flags_KI_svg__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(58327);
/* harmony import */ var _assets_flags_KM_svg__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(66078);
/* harmony import */ var _assets_flags_KN_svg__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(66688);
/* harmony import */ var _assets_flags_KP_svg__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(29874);
/* harmony import */ var _assets_flags_KW_svg__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(27820);
/* harmony import */ var _assets_flags_KZ_svg__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(7061);
/* harmony import */ var _assets_flags_LA_svg__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(3228);
/* harmony import */ var _assets_flags_LB_svg__WEBPACK_IMPORTED_MODULE_107__ = __webpack_require__(87037);
/* harmony import */ var _assets_flags_LC_svg__WEBPACK_IMPORTED_MODULE_108__ = __webpack_require__(69691);
/* harmony import */ var _assets_flags_LI_svg__WEBPACK_IMPORTED_MODULE_109__ = __webpack_require__(35136);
/* harmony import */ var _assets_flags_LK_svg__WEBPACK_IMPORTED_MODULE_110__ = __webpack_require__(31897);
/* harmony import */ var _assets_flags_LR_svg__WEBPACK_IMPORTED_MODULE_111__ = __webpack_require__(87238);
/* harmony import */ var _assets_flags_LS_svg__WEBPACK_IMPORTED_MODULE_112__ = __webpack_require__(27991);
/* harmony import */ var _assets_flags_LT_svg__WEBPACK_IMPORTED_MODULE_113__ = __webpack_require__(10788);
/* harmony import */ var _assets_flags_LU_svg__WEBPACK_IMPORTED_MODULE_114__ = __webpack_require__(59058);
/* harmony import */ var _assets_flags_LV_svg__WEBPACK_IMPORTED_MODULE_115__ = __webpack_require__(26913);
/* harmony import */ var _assets_flags_LY_svg__WEBPACK_IMPORTED_MODULE_116__ = __webpack_require__(92385);
/* harmony import */ var _assets_flags_MA_svg__WEBPACK_IMPORTED_MODULE_117__ = __webpack_require__(75224);
/* harmony import */ var _assets_flags_MC_svg__WEBPACK_IMPORTED_MODULE_118__ = __webpack_require__(42357);
/* harmony import */ var _assets_flags_MD_svg__WEBPACK_IMPORTED_MODULE_119__ = __webpack_require__(71576);
/* harmony import */ var _assets_flags_ME_svg__WEBPACK_IMPORTED_MODULE_120__ = __webpack_require__(50109);
/* harmony import */ var _assets_flags_MG_svg__WEBPACK_IMPORTED_MODULE_121__ = __webpack_require__(52793);
/* harmony import */ var _assets_flags_MH_svg__WEBPACK_IMPORTED_MODULE_122__ = __webpack_require__(45557);
/* harmony import */ var _assets_flags_MK_svg__WEBPACK_IMPORTED_MODULE_123__ = __webpack_require__(71406);
/* harmony import */ var _assets_flags_ML_svg__WEBPACK_IMPORTED_MODULE_124__ = __webpack_require__(81491);
/* harmony import */ var _assets_flags_MM_svg__WEBPACK_IMPORTED_MODULE_125__ = __webpack_require__(43588);
/* harmony import */ var _assets_flags_MN_svg__WEBPACK_IMPORTED_MODULE_126__ = __webpack_require__(11334);
/* harmony import */ var _assets_flags_MO_svg__WEBPACK_IMPORTED_MODULE_127__ = __webpack_require__(56387);
/* harmony import */ var _assets_flags_MR_svg__WEBPACK_IMPORTED_MODULE_128__ = __webpack_require__(72844);
/* harmony import */ var _assets_flags_MT_svg__WEBPACK_IMPORTED_MODULE_129__ = __webpack_require__(41333);
/* harmony import */ var _assets_flags_MU_svg__WEBPACK_IMPORTED_MODULE_130__ = __webpack_require__(53142);
/* harmony import */ var _assets_flags_MV_svg__WEBPACK_IMPORTED_MODULE_131__ = __webpack_require__(84027);
/* harmony import */ var _assets_flags_MW_svg__WEBPACK_IMPORTED_MODULE_132__ = __webpack_require__(14781);
/* harmony import */ var _assets_flags_MX_svg__WEBPACK_IMPORTED_MODULE_133__ = __webpack_require__(86803);
/* harmony import */ var _assets_flags_MZ_svg__WEBPACK_IMPORTED_MODULE_134__ = __webpack_require__(66976);
/* harmony import */ var _assets_flags_NA_svg__WEBPACK_IMPORTED_MODULE_135__ = __webpack_require__(20787);
/* harmony import */ var _assets_flags_NE_svg__WEBPACK_IMPORTED_MODULE_136__ = __webpack_require__(25381);
/* harmony import */ var _assets_flags_NG_svg__WEBPACK_IMPORTED_MODULE_137__ = __webpack_require__(3503);
/* harmony import */ var _assets_flags_NI_svg__WEBPACK_IMPORTED_MODULE_138__ = __webpack_require__(72415);
/* harmony import */ var _assets_flags_NL_svg__WEBPACK_IMPORTED_MODULE_139__ = __webpack_require__(50068);
/* harmony import */ var _assets_flags_NP_svg__WEBPACK_IMPORTED_MODULE_140__ = __webpack_require__(62680);
/* harmony import */ var _assets_flags_NR_svg__WEBPACK_IMPORTED_MODULE_141__ = __webpack_require__(22352);
/* harmony import */ var _assets_flags_NZ_svg__WEBPACK_IMPORTED_MODULE_142__ = __webpack_require__(81537);
/* harmony import */ var _assets_flags_OM_svg__WEBPACK_IMPORTED_MODULE_143__ = __webpack_require__(88941);
/* harmony import */ var _assets_flags_PA_svg__WEBPACK_IMPORTED_MODULE_144__ = __webpack_require__(68630);
/* harmony import */ var _assets_flags_PE_svg__WEBPACK_IMPORTED_MODULE_145__ = __webpack_require__(82429);
/* harmony import */ var _assets_flags_PG_svg__WEBPACK_IMPORTED_MODULE_146__ = __webpack_require__(57518);
/* harmony import */ var _assets_flags_PK_svg__WEBPACK_IMPORTED_MODULE_147__ = __webpack_require__(7766);
/* harmony import */ var _assets_flags_PL_svg__WEBPACK_IMPORTED_MODULE_148__ = __webpack_require__(19437);
/* harmony import */ var _assets_flags_PS_svg__WEBPACK_IMPORTED_MODULE_149__ = __webpack_require__(92814);
/* harmony import */ var _assets_flags_PT_svg__WEBPACK_IMPORTED_MODULE_150__ = __webpack_require__(38827);
/* harmony import */ var _assets_flags_PW_svg__WEBPACK_IMPORTED_MODULE_151__ = __webpack_require__(9692);
/* harmony import */ var _assets_flags_PY_svg__WEBPACK_IMPORTED_MODULE_152__ = __webpack_require__(43120);
/* harmony import */ var _assets_flags_RO_svg__WEBPACK_IMPORTED_MODULE_153__ = __webpack_require__(78132);
/* harmony import */ var _assets_flags_RS_svg__WEBPACK_IMPORTED_MODULE_154__ = __webpack_require__(27430);
/* harmony import */ var _assets_flags_RU_svg__WEBPACK_IMPORTED_MODULE_155__ = __webpack_require__(49585);
/* harmony import */ var _assets_flags_RW_svg__WEBPACK_IMPORTED_MODULE_156__ = __webpack_require__(55118);
/* harmony import */ var _assets_flags_SA_svg__WEBPACK_IMPORTED_MODULE_157__ = __webpack_require__(82009);
/* harmony import */ var _assets_flags_SB_svg__WEBPACK_IMPORTED_MODULE_158__ = __webpack_require__(23661);
/* harmony import */ var _assets_flags_SC_svg__WEBPACK_IMPORTED_MODULE_159__ = __webpack_require__(71306);
/* harmony import */ var _assets_flags_SD_svg__WEBPACK_IMPORTED_MODULE_160__ = __webpack_require__(82606);
/* harmony import */ var _assets_flags_SE_svg__WEBPACK_IMPORTED_MODULE_161__ = __webpack_require__(9758);
/* harmony import */ var _assets_flags_SI_svg__WEBPACK_IMPORTED_MODULE_162__ = __webpack_require__(77644);
/* harmony import */ var _assets_flags_SK_svg__WEBPACK_IMPORTED_MODULE_163__ = __webpack_require__(49862);
/* harmony import */ var _assets_flags_SL_svg__WEBPACK_IMPORTED_MODULE_164__ = __webpack_require__(74585);
/* harmony import */ var _assets_flags_SM_svg__WEBPACK_IMPORTED_MODULE_165__ = __webpack_require__(14073);
/* harmony import */ var _assets_flags_SN_svg__WEBPACK_IMPORTED_MODULE_166__ = __webpack_require__(7232);
/* harmony import */ var _assets_flags_SO_svg__WEBPACK_IMPORTED_MODULE_167__ = __webpack_require__(69271);
/* harmony import */ var _assets_flags_SR_svg__WEBPACK_IMPORTED_MODULE_168__ = __webpack_require__(46422);
/* harmony import */ var _assets_flags_SS_svg__WEBPACK_IMPORTED_MODULE_169__ = __webpack_require__(46201);
/* harmony import */ var _assets_flags_ST_svg__WEBPACK_IMPORTED_MODULE_170__ = __webpack_require__(69451);
/* harmony import */ var _assets_flags_SV_svg__WEBPACK_IMPORTED_MODULE_171__ = __webpack_require__(66850);
/* harmony import */ var _assets_flags_SY_svg__WEBPACK_IMPORTED_MODULE_172__ = __webpack_require__(89556);
/* harmony import */ var _assets_flags_SZ_svg__WEBPACK_IMPORTED_MODULE_173__ = __webpack_require__(2548);
/* harmony import */ var _assets_flags_TD_svg__WEBPACK_IMPORTED_MODULE_174__ = __webpack_require__(28718);
/* harmony import */ var _assets_flags_TG_svg__WEBPACK_IMPORTED_MODULE_175__ = __webpack_require__(9567);
/* harmony import */ var _assets_flags_TJ_svg__WEBPACK_IMPORTED_MODULE_176__ = __webpack_require__(76939);
/* harmony import */ var _assets_flags_TL_svg__WEBPACK_IMPORTED_MODULE_177__ = __webpack_require__(16491);
/* harmony import */ var _assets_flags_TM_svg__WEBPACK_IMPORTED_MODULE_178__ = __webpack_require__(36529);
/* harmony import */ var _assets_flags_TN_svg__WEBPACK_IMPORTED_MODULE_179__ = __webpack_require__(23926);
/* harmony import */ var _assets_flags_TO_svg__WEBPACK_IMPORTED_MODULE_180__ = __webpack_require__(42916);
/* harmony import */ var _assets_flags_TT_svg__WEBPACK_IMPORTED_MODULE_181__ = __webpack_require__(4735);
/* harmony import */ var _assets_flags_TV_svg__WEBPACK_IMPORTED_MODULE_182__ = __webpack_require__(9425);
/* harmony import */ var _assets_flags_TW_svg__WEBPACK_IMPORTED_MODULE_183__ = __webpack_require__(54508);
/* harmony import */ var _assets_flags_TZ_svg__WEBPACK_IMPORTED_MODULE_184__ = __webpack_require__(49286);
/* harmony import */ var _assets_flags_UA_svg__WEBPACK_IMPORTED_MODULE_185__ = __webpack_require__(20402);
/* harmony import */ var _assets_flags_UG_svg__WEBPACK_IMPORTED_MODULE_186__ = __webpack_require__(52902);
/* harmony import */ var _assets_flags_UY_svg__WEBPACK_IMPORTED_MODULE_187__ = __webpack_require__(5087);
/* harmony import */ var _assets_flags_UZ_svg__WEBPACK_IMPORTED_MODULE_188__ = __webpack_require__(27228);
/* harmony import */ var _assets_flags_VA_svg__WEBPACK_IMPORTED_MODULE_189__ = __webpack_require__(82292);
/* harmony import */ var _assets_flags_VC_svg__WEBPACK_IMPORTED_MODULE_190__ = __webpack_require__(81035);
/* harmony import */ var _assets_flags_VE_svg__WEBPACK_IMPORTED_MODULE_191__ = __webpack_require__(32984);
/* harmony import */ var _assets_flags_VU_svg__WEBPACK_IMPORTED_MODULE_192__ = __webpack_require__(36147);
/* harmony import */ var _assets_flags_WS_svg__WEBPACK_IMPORTED_MODULE_193__ = __webpack_require__(86845);
/* harmony import */ var _assets_flags_YE_svg__WEBPACK_IMPORTED_MODULE_194__ = __webpack_require__(12166);
/* harmony import */ var _assets_flags_ZA_svg__WEBPACK_IMPORTED_MODULE_195__ = __webpack_require__(16210);


























































































































































































 // import UK from '@/assets/flags/UK.svg'












/* harmony default export */ __webpack_exports__["Z"] = ({
  GB: _assets_flags_GB_svg__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
  ID: _assets_flags_ID_svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
  MY: _assets_flags_MY_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
  PH: _assets_flags_PH_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
  SG: _assets_flags_SG_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
  TH: _assets_flags_TH_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
  US: _assets_flags_US_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
  VN: _assets_flags_VN_svg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
  IT: _assets_flags_IT_svg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
  TR: _assets_flags_TR_svg__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
  CN: _assets_flags_CN_svg__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
  AR: _assets_flags_AR_svg__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z,
  GLOBAL: _assets_flags_globe_svg__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
  BR: _assets_flags_BR_svg__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z,
  KR: _assets_flags_KR_svg__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z,
  QA: _assets_flags_QA_svg__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z,
  AD: _assets_flags_AD_svg__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z,
  AE: _assets_flags_AE_svg__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z,
  AF: _assets_flags_AF_svg__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z,
  AG: _assets_flags_AG_svg__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z,
  AL: _assets_flags_AL_svg__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z,
  AM: _assets_flags_AM_svg__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z,
  AO: _assets_flags_AO_svg__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z,
  AT: _assets_flags_AT_svg__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z,
  AU: _assets_flags_AU_svg__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z,
  AZ: _assets_flags_AZ_svg__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z,
  BA: _assets_flags_BA_svg__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z,
  BB: _assets_flags_BB_svg__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z,
  BD: _assets_flags_BD_svg__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z,
  BE: _assets_flags_BE_svg__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z,
  BF: _assets_flags_BF_svg__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z,
  BG: _assets_flags_BG_svg__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z,
  BH: _assets_flags_BH_svg__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z,
  BI: _assets_flags_BI_svg__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z,
  BJ: _assets_flags_BJ_svg__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z,
  BN: _assets_flags_BN_svg__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z,
  BO: _assets_flags_BO_svg__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z,
  BS: _assets_flags_BS_svg__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z,
  BT: _assets_flags_BT_svg__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z,
  BW: _assets_flags_BW_svg__WEBPACK_IMPORTED_MODULE_39__/* ["default"] */ .Z,
  BY: _assets_flags_BY_svg__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z,
  BZ: _assets_flags_BZ_svg__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z,
  CA: _assets_flags_CA_svg__WEBPACK_IMPORTED_MODULE_42__/* ["default"] */ .Z,
  CD: _assets_flags_CD_svg__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z,
  CF: _assets_flags_CF_svg__WEBPACK_IMPORTED_MODULE_44__/* ["default"] */ .Z,
  CG: _assets_flags_CG_svg__WEBPACK_IMPORTED_MODULE_45__/* ["default"] */ .Z,
  CH: _assets_flags_CH_svg__WEBPACK_IMPORTED_MODULE_46__/* ["default"] */ .Z,
  CI: _assets_flags_CI_svg__WEBPACK_IMPORTED_MODULE_47__/* ["default"] */ .Z,
  CL: _assets_flags_CL_svg__WEBPACK_IMPORTED_MODULE_48__/* ["default"] */ .Z,
  CM: _assets_flags_CM_svg__WEBPACK_IMPORTED_MODULE_49__/* ["default"] */ .Z,
  CO: _assets_flags_CO_svg__WEBPACK_IMPORTED_MODULE_50__/* ["default"] */ .Z,
  CR: _assets_flags_CR_svg__WEBPACK_IMPORTED_MODULE_51__/* ["default"] */ .Z,
  CU: _assets_flags_CU_svg__WEBPACK_IMPORTED_MODULE_52__/* ["default"] */ .Z,
  CV: _assets_flags_CV_svg__WEBPACK_IMPORTED_MODULE_53__/* ["default"] */ .Z,
  CY: _assets_flags_CY_svg__WEBPACK_IMPORTED_MODULE_54__/* ["default"] */ .Z,
  CZ: _assets_flags_CZ_svg__WEBPACK_IMPORTED_MODULE_55__/* ["default"] */ .Z,
  DE: _assets_flags_DE_svg__WEBPACK_IMPORTED_MODULE_56__/* ["default"] */ .Z,
  DJ: _assets_flags_DJ_svg__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z,
  DK: _assets_flags_DK_svg__WEBPACK_IMPORTED_MODULE_58__/* ["default"] */ .Z,
  DM: _assets_flags_DM_svg__WEBPACK_IMPORTED_MODULE_59__/* ["default"] */ .Z,
  DO: _assets_flags_DO_svg__WEBPACK_IMPORTED_MODULE_60__/* ["default"] */ .Z,
  DZ: _assets_flags_DZ_svg__WEBPACK_IMPORTED_MODULE_61__/* ["default"] */ .Z,
  EC: _assets_flags_EC_svg__WEBPACK_IMPORTED_MODULE_62__/* ["default"] */ .Z,
  EE: _assets_flags_EE_svg__WEBPACK_IMPORTED_MODULE_63__/* ["default"] */ .Z,
  EG: _assets_flags_EG_svg__WEBPACK_IMPORTED_MODULE_64__/* ["default"] */ .Z,
  ER: _assets_flags_ER_svg__WEBPACK_IMPORTED_MODULE_65__/* ["default"] */ .Z,
  ES: _assets_flags_ES_svg__WEBPACK_IMPORTED_MODULE_66__/* ["default"] */ .Z,
  ET: _assets_flags_ET_svg__WEBPACK_IMPORTED_MODULE_67__/* ["default"] */ .Z,
  FI: _assets_flags_FI_svg__WEBPACK_IMPORTED_MODULE_68__/* ["default"] */ .Z,
  FJ: _assets_flags_FJ_svg__WEBPACK_IMPORTED_MODULE_69__/* ["default"] */ .Z,
  FM: _assets_flags_FM_svg__WEBPACK_IMPORTED_MODULE_70__/* ["default"] */ .Z,
  FR: _assets_flags_FR_svg__WEBPACK_IMPORTED_MODULE_71__/* ["default"] */ .Z,
  GA: _assets_flags_GA_svg__WEBPACK_IMPORTED_MODULE_72__/* ["default"] */ .Z,
  GD: _assets_flags_GD_svg__WEBPACK_IMPORTED_MODULE_73__/* ["default"] */ .Z,
  GE: _assets_flags_GE_svg__WEBPACK_IMPORTED_MODULE_74__/* ["default"] */ .Z,
  GH: _assets_flags_GH_svg__WEBPACK_IMPORTED_MODULE_75__/* ["default"] */ .Z,
  GM: _assets_flags_GM_svg__WEBPACK_IMPORTED_MODULE_76__/* ["default"] */ .Z,
  GN: _assets_flags_GN_svg__WEBPACK_IMPORTED_MODULE_77__/* ["default"] */ .Z,
  GQ: _assets_flags_GQ_svg__WEBPACK_IMPORTED_MODULE_78__/* ["default"] */ .Z,
  GR: _assets_flags_GR_svg__WEBPACK_IMPORTED_MODULE_79__/* ["default"] */ .Z,
  GT: _assets_flags_GT_svg__WEBPACK_IMPORTED_MODULE_80__/* ["default"] */ .Z,
  GW: _assets_flags_GW_svg__WEBPACK_IMPORTED_MODULE_81__/* ["default"] */ .Z,
  GY: _assets_flags_GY_svg__WEBPACK_IMPORTED_MODULE_82__/* ["default"] */ .Z,
  HK: _assets_flags_HK_svg__WEBPACK_IMPORTED_MODULE_83__/* ["default"] */ .Z,
  HN: _assets_flags_HN_svg__WEBPACK_IMPORTED_MODULE_84__/* ["default"] */ .Z,
  HR: _assets_flags_HR_svg__WEBPACK_IMPORTED_MODULE_85__/* ["default"] */ .Z,
  HT: _assets_flags_HT_svg__WEBPACK_IMPORTED_MODULE_86__/* ["default"] */ .Z,
  HU: _assets_flags_HU_svg__WEBPACK_IMPORTED_MODULE_87__/* ["default"] */ .Z,
  IE: _assets_flags_IE_svg__WEBPACK_IMPORTED_MODULE_88__/* ["default"] */ .Z,
  IL: _assets_flags_IL_svg__WEBPACK_IMPORTED_MODULE_89__/* ["default"] */ .Z,
  IN: _assets_flags_IN_svg__WEBPACK_IMPORTED_MODULE_90__/* ["default"] */ .Z,
  IQ: _assets_flags_IQ_svg__WEBPACK_IMPORTED_MODULE_91__/* ["default"] */ .Z,
  IR: _assets_flags_IR_svg__WEBPACK_IMPORTED_MODULE_92__/* ["default"] */ .Z,
  IS: _assets_flags_IS_svg__WEBPACK_IMPORTED_MODULE_93__/* ["default"] */ .Z,
  JM: _assets_flags_JM_svg__WEBPACK_IMPORTED_MODULE_94__/* ["default"] */ .Z,
  JO: _assets_flags_JO_svg__WEBPACK_IMPORTED_MODULE_95__/* ["default"] */ .Z,
  JP: _assets_flags_JP_svg__WEBPACK_IMPORTED_MODULE_96__/* ["default"] */ .Z,
  KE: _assets_flags_KE_svg__WEBPACK_IMPORTED_MODULE_97__/* ["default"] */ .Z,
  KG: _assets_flags_KG_svg__WEBPACK_IMPORTED_MODULE_98__/* ["default"] */ .Z,
  KH: _assets_flags_KH_svg__WEBPACK_IMPORTED_MODULE_99__/* ["default"] */ .Z,
  KI: _assets_flags_KI_svg__WEBPACK_IMPORTED_MODULE_100__/* ["default"] */ .Z,
  KM: _assets_flags_KM_svg__WEBPACK_IMPORTED_MODULE_101__/* ["default"] */ .Z,
  KN: _assets_flags_KN_svg__WEBPACK_IMPORTED_MODULE_102__/* ["default"] */ .Z,
  KP: _assets_flags_KP_svg__WEBPACK_IMPORTED_MODULE_103__/* ["default"] */ .Z,
  KW: _assets_flags_KW_svg__WEBPACK_IMPORTED_MODULE_104__/* ["default"] */ .Z,
  KZ: _assets_flags_KZ_svg__WEBPACK_IMPORTED_MODULE_105__/* ["default"] */ .Z,
  LA: _assets_flags_LA_svg__WEBPACK_IMPORTED_MODULE_106__/* ["default"] */ .Z,
  LB: _assets_flags_LB_svg__WEBPACK_IMPORTED_MODULE_107__/* ["default"] */ .Z,
  LC: _assets_flags_LC_svg__WEBPACK_IMPORTED_MODULE_108__/* ["default"] */ .Z,
  LI: _assets_flags_LI_svg__WEBPACK_IMPORTED_MODULE_109__/* ["default"] */ .Z,
  LK: _assets_flags_LK_svg__WEBPACK_IMPORTED_MODULE_110__/* ["default"] */ .Z,
  LR: _assets_flags_LR_svg__WEBPACK_IMPORTED_MODULE_111__/* ["default"] */ .Z,
  LS: _assets_flags_LS_svg__WEBPACK_IMPORTED_MODULE_112__/* ["default"] */ .Z,
  LT: _assets_flags_LT_svg__WEBPACK_IMPORTED_MODULE_113__/* ["default"] */ .Z,
  LU: _assets_flags_LU_svg__WEBPACK_IMPORTED_MODULE_114__/* ["default"] */ .Z,
  LV: _assets_flags_LV_svg__WEBPACK_IMPORTED_MODULE_115__/* ["default"] */ .Z,
  LY: _assets_flags_LY_svg__WEBPACK_IMPORTED_MODULE_116__/* ["default"] */ .Z,
  MA: _assets_flags_MA_svg__WEBPACK_IMPORTED_MODULE_117__/* ["default"] */ .Z,
  MC: _assets_flags_MC_svg__WEBPACK_IMPORTED_MODULE_118__/* ["default"] */ .Z,
  MD: _assets_flags_MD_svg__WEBPACK_IMPORTED_MODULE_119__/* ["default"] */ .Z,
  ME: _assets_flags_ME_svg__WEBPACK_IMPORTED_MODULE_120__/* ["default"] */ .Z,
  MG: _assets_flags_MG_svg__WEBPACK_IMPORTED_MODULE_121__/* ["default"] */ .Z,
  MH: _assets_flags_MH_svg__WEBPACK_IMPORTED_MODULE_122__/* ["default"] */ .Z,
  MK: _assets_flags_MK_svg__WEBPACK_IMPORTED_MODULE_123__/* ["default"] */ .Z,
  ML: _assets_flags_ML_svg__WEBPACK_IMPORTED_MODULE_124__/* ["default"] */ .Z,
  MM: _assets_flags_MM_svg__WEBPACK_IMPORTED_MODULE_125__/* ["default"] */ .Z,
  MN: _assets_flags_MN_svg__WEBPACK_IMPORTED_MODULE_126__/* ["default"] */ .Z,
  MO: _assets_flags_MO_svg__WEBPACK_IMPORTED_MODULE_127__/* ["default"] */ .Z,
  MR: _assets_flags_MR_svg__WEBPACK_IMPORTED_MODULE_128__/* ["default"] */ .Z,
  MT: _assets_flags_MT_svg__WEBPACK_IMPORTED_MODULE_129__/* ["default"] */ .Z,
  MU: _assets_flags_MU_svg__WEBPACK_IMPORTED_MODULE_130__/* ["default"] */ .Z,
  MV: _assets_flags_MV_svg__WEBPACK_IMPORTED_MODULE_131__/* ["default"] */ .Z,
  MW: _assets_flags_MW_svg__WEBPACK_IMPORTED_MODULE_132__/* ["default"] */ .Z,
  MX: _assets_flags_MX_svg__WEBPACK_IMPORTED_MODULE_133__/* ["default"] */ .Z,
  MZ: _assets_flags_MZ_svg__WEBPACK_IMPORTED_MODULE_134__/* ["default"] */ .Z,
  NA: _assets_flags_NA_svg__WEBPACK_IMPORTED_MODULE_135__/* ["default"] */ .Z,
  NE: _assets_flags_NE_svg__WEBPACK_IMPORTED_MODULE_136__/* ["default"] */ .Z,
  NG: _assets_flags_NG_svg__WEBPACK_IMPORTED_MODULE_137__/* ["default"] */ .Z,
  NI: _assets_flags_NI_svg__WEBPACK_IMPORTED_MODULE_138__/* ["default"] */ .Z,
  NL: _assets_flags_NL_svg__WEBPACK_IMPORTED_MODULE_139__/* ["default"] */ .Z,
  NP: _assets_flags_NP_svg__WEBPACK_IMPORTED_MODULE_140__/* ["default"] */ .Z,
  NR: _assets_flags_NR_svg__WEBPACK_IMPORTED_MODULE_141__/* ["default"] */ .Z,
  NZ: _assets_flags_NZ_svg__WEBPACK_IMPORTED_MODULE_142__/* ["default"] */ .Z,
  OM: _assets_flags_OM_svg__WEBPACK_IMPORTED_MODULE_143__/* ["default"] */ .Z,
  PA: _assets_flags_PA_svg__WEBPACK_IMPORTED_MODULE_144__/* ["default"] */ .Z,
  PE: _assets_flags_PE_svg__WEBPACK_IMPORTED_MODULE_145__/* ["default"] */ .Z,
  PG: _assets_flags_PG_svg__WEBPACK_IMPORTED_MODULE_146__/* ["default"] */ .Z,
  PK: _assets_flags_PK_svg__WEBPACK_IMPORTED_MODULE_147__/* ["default"] */ .Z,
  PL: _assets_flags_PL_svg__WEBPACK_IMPORTED_MODULE_148__/* ["default"] */ .Z,
  PS: _assets_flags_PS_svg__WEBPACK_IMPORTED_MODULE_149__/* ["default"] */ .Z,
  PT: _assets_flags_PT_svg__WEBPACK_IMPORTED_MODULE_150__/* ["default"] */ .Z,
  PW: _assets_flags_PW_svg__WEBPACK_IMPORTED_MODULE_151__/* ["default"] */ .Z,
  PY: _assets_flags_PY_svg__WEBPACK_IMPORTED_MODULE_152__/* ["default"] */ .Z,
  RO: _assets_flags_RO_svg__WEBPACK_IMPORTED_MODULE_153__/* ["default"] */ .Z,
  RS: _assets_flags_RS_svg__WEBPACK_IMPORTED_MODULE_154__/* ["default"] */ .Z,
  RU: _assets_flags_RU_svg__WEBPACK_IMPORTED_MODULE_155__/* ["default"] */ .Z,
  RW: _assets_flags_RW_svg__WEBPACK_IMPORTED_MODULE_156__/* ["default"] */ .Z,
  SA: _assets_flags_SA_svg__WEBPACK_IMPORTED_MODULE_157__/* ["default"] */ .Z,
  SB: _assets_flags_SB_svg__WEBPACK_IMPORTED_MODULE_158__/* ["default"] */ .Z,
  SC: _assets_flags_SC_svg__WEBPACK_IMPORTED_MODULE_159__/* ["default"] */ .Z,
  SD: _assets_flags_SD_svg__WEBPACK_IMPORTED_MODULE_160__/* ["default"] */ .Z,
  SE: _assets_flags_SE_svg__WEBPACK_IMPORTED_MODULE_161__/* ["default"] */ .Z,
  SI: _assets_flags_SI_svg__WEBPACK_IMPORTED_MODULE_162__/* ["default"] */ .Z,
  SK: _assets_flags_SK_svg__WEBPACK_IMPORTED_MODULE_163__/* ["default"] */ .Z,
  SL: _assets_flags_SL_svg__WEBPACK_IMPORTED_MODULE_164__/* ["default"] */ .Z,
  SM: _assets_flags_SM_svg__WEBPACK_IMPORTED_MODULE_165__/* ["default"] */ .Z,
  SN: _assets_flags_SN_svg__WEBPACK_IMPORTED_MODULE_166__/* ["default"] */ .Z,
  SO: _assets_flags_SO_svg__WEBPACK_IMPORTED_MODULE_167__/* ["default"] */ .Z,
  SR: _assets_flags_SR_svg__WEBPACK_IMPORTED_MODULE_168__/* ["default"] */ .Z,
  SS: _assets_flags_SS_svg__WEBPACK_IMPORTED_MODULE_169__/* ["default"] */ .Z,
  ST: _assets_flags_ST_svg__WEBPACK_IMPORTED_MODULE_170__/* ["default"] */ .Z,
  SV: _assets_flags_SV_svg__WEBPACK_IMPORTED_MODULE_171__/* ["default"] */ .Z,
  SY: _assets_flags_SY_svg__WEBPACK_IMPORTED_MODULE_172__/* ["default"] */ .Z,
  SZ: _assets_flags_SZ_svg__WEBPACK_IMPORTED_MODULE_173__/* ["default"] */ .Z,
  TD: _assets_flags_TD_svg__WEBPACK_IMPORTED_MODULE_174__/* ["default"] */ .Z,
  TG: _assets_flags_TG_svg__WEBPACK_IMPORTED_MODULE_175__/* ["default"] */ .Z,
  TJ: _assets_flags_TJ_svg__WEBPACK_IMPORTED_MODULE_176__/* ["default"] */ .Z,
  TL: _assets_flags_TL_svg__WEBPACK_IMPORTED_MODULE_177__/* ["default"] */ .Z,
  TM: _assets_flags_TM_svg__WEBPACK_IMPORTED_MODULE_178__/* ["default"] */ .Z,
  TN: _assets_flags_TN_svg__WEBPACK_IMPORTED_MODULE_179__/* ["default"] */ .Z,
  TO: _assets_flags_TO_svg__WEBPACK_IMPORTED_MODULE_180__/* ["default"] */ .Z,
  TT: _assets_flags_TT_svg__WEBPACK_IMPORTED_MODULE_181__/* ["default"] */ .Z,
  TV: _assets_flags_TV_svg__WEBPACK_IMPORTED_MODULE_182__/* ["default"] */ .Z,
  TW: _assets_flags_TW_svg__WEBPACK_IMPORTED_MODULE_183__/* ["default"] */ .Z,
  TZ: _assets_flags_TZ_svg__WEBPACK_IMPORTED_MODULE_184__/* ["default"] */ .Z,
  UA: _assets_flags_UA_svg__WEBPACK_IMPORTED_MODULE_185__/* ["default"] */ .Z,
  UG: _assets_flags_UG_svg__WEBPACK_IMPORTED_MODULE_186__/* ["default"] */ .Z,
  // UK,
  UY: _assets_flags_UY_svg__WEBPACK_IMPORTED_MODULE_187__/* ["default"] */ .Z,
  UZ: _assets_flags_UZ_svg__WEBPACK_IMPORTED_MODULE_188__/* ["default"] */ .Z,
  VA: _assets_flags_VA_svg__WEBPACK_IMPORTED_MODULE_189__/* ["default"] */ .Z,
  VC: _assets_flags_VC_svg__WEBPACK_IMPORTED_MODULE_190__/* ["default"] */ .Z,
  VE: _assets_flags_VE_svg__WEBPACK_IMPORTED_MODULE_191__/* ["default"] */ .Z,
  VU: _assets_flags_VU_svg__WEBPACK_IMPORTED_MODULE_192__/* ["default"] */ .Z,
  WS: _assets_flags_WS_svg__WEBPACK_IMPORTED_MODULE_193__/* ["default"] */ .Z,
  YE: _assets_flags_YE_svg__WEBPACK_IMPORTED_MODULE_194__/* ["default"] */ .Z,
  ZA: _assets_flags_ZA_svg__WEBPACK_IMPORTED_MODULE_195__/* ["default"] */ .Z,
  ZM: _assets_flags_VC_svg__WEBPACK_IMPORTED_MODULE_190__/* ["default"] */ .Z,
  ZW: _assets_flags_VC_svg__WEBPACK_IMPORTED_MODULE_190__/* ["default"] */ .Z
});

/***/ }),

/***/ 43059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43397);
/* harmony import */ var _utils_checkLogin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23199);




class SearchHistoryCache {
  constructor() {
    (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "CACHE_KEY", '__search_history_cache__');

    (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "defaultHistory", {
      [_types_common__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.Influencer */ .ai.Influencer]: [],
      [_types_common__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.Live */ .ai.Live]: [],
      [_types_common__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.Video */ .ai.Video]: [],
      [_types_common__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.Product */ .ai.Product]: [],
      [_types_common__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.Shop */ .ai.Shop]: [],
      [_types_common__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.Hashtag */ .ai.Hashtag]: []
    });
  }

  get token() {
    return (0,_utils_checkLogin__WEBPACK_IMPORTED_MODULE_1__/* .getToken */ .LP)();
  }

  resetCache() {
    localStorage.removeItem(this.CACHE_KEY);
  }

  getCache() {
    const str = localStorage.getItem(this.CACHE_KEY);

    if (!str) {
      return this.defaultHistory;
    }

    const fn = this.generateCache;
    const cache = JSON.parse(str); // 当前用户 token 与缓存时的 token 不一致，视为缓存失效
    // if (cache.token !== this.token) {
    //   this.resetCache()
    //   return this.defaultHistory
    // }

    return cache.history;
  }

  setCache(history) {
    localStorage.setItem(this.CACHE_KEY, JSON.stringify(this.generateCache(history)));
  }

  generateCache(history) {
    return {
      token: this.token,
      history
    };
  }

}

/* harmony default export */ __webpack_exports__["Z"] = (new SearchHistoryCache());

/***/ }),

/***/ 27989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ RenderPageLink; },
/* harmony export */   "_": function() { return /* binding */ RenderCanonical; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




const RenderCanonical = function () {
  let host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'echotik.live';
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  const originUrl = `https://${host}${router.asPath}`;
  const urlParts = originUrl.split('?');
  const baseUrl = urlParts[0];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
    rel: "canonical",
    href: baseUrl
  });
};
const libraryPaths = ['/influencers', '/products', '/shops', '/live'];
const RenderPageLink = tableData => {
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  const {
    pathname,
    query,
    asPath
  } = router;
  const curPage = query.page;
  let maxPage = 0;

  if (tableData && typeof tableData === 'object') {
    if (tableData !== null && tableData !== void 0 && tableData.total && tableData !== null && tableData !== void 0 && tableData.pageSize) {
      maxPage = Math.ceil((tableData === null || tableData === void 0 ? void 0 : tableData.total) / (tableData === null || tableData === void 0 ? void 0 : tableData.pageSize));
    }
  }

  if (pathname.includes('/page/') && curPage) {
    const curPageNum = Number(curPage);
    const nextHref = pathname.replace('[page]', `${curPageNum + 1}`);

    if (curPageNum === 1) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
        rel: "next",
        href: nextHref
      });
    } else if (curPageNum === 2) {
      const prevHref = pathname.replace('/page/[page]', '');
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
          rel: "prev",
          href: prevHref
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
          rel: "next",
          href: nextHref
        })]
      });
    } else if (maxPage > 0 && curPageNum === maxPage) {
      // 最后一页
      const prevHref = pathname.replace('[page]', `${curPageNum - 1}`);
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
          rel: "prev",
          href: prevHref
        })
      });
    } else {
      const prevHref = pathname.replace('[page]', `${curPageNum - 1}`);
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
          rel: "prev",
          href: prevHref
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
          rel: "next",
          href: nextHref
        })]
      });
    }
  } else if (libraryPaths.includes(pathname) && !pathname.includes('/page/')) {
    // 库
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "next",
      href: `${pathname}/page/2`
    });
  } else if (pathname.includes('/leaderboard/') && !pathname.includes('/page/') && asPath) {
    // 非seo榜单
    const urlArr = asPath.split('?');
    const basePath = urlArr[0];
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "next",
      href: `${basePath}/page/2`
    });
  }

  return null;
};

/***/ }),

/***/ 83126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59544);
/* harmony import */ var _locale_locale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74631);

 // import { importLocaleData, enLocale } from '@/locale/locale'



function useLocale() {
  const {
    lang
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_1__/* .GlobalContext */ .kn);
  return _locale_locale__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[lang]; // const [langData, setLangData] = useState<Record<string, string>>(enLocale)
  // useEffect(() => {
  //   const asyncImportLocaleData = async () => {
  //     if (!lang) {
  //       return
  //     }
  //     importLocaleData(lang).then((data) => {
  //       setLangData(data)
  //     })
  //   }
  //   asyncImportLocaleData()
  // }, [lang])
  // return langData
}

/* harmony default export */ __webpack_exports__["Z"] = (useLocale);

/***/ }),

/***/ 42644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1405);
// https://stackoverflow.com/questions/68424114/next-js-how-to-fetch-localstorage-data-before-client-side-rendering
// 解决 nextJS 无法获取初始localstorage问题



const getDefaultStorage = key => {
  if (!_utils_is__WEBPACK_IMPORTED_MODULE_1__/* .isSSR */ .yF) {
    return localStorage.getItem(key);
  } else {
    return undefined;
  }
};

function useStorage(key, defaultValue) {
  const {
    0: storedValue,
    1: setStoredValue
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getDefaultStorage(key) || defaultValue);

  const setStorageValue = value => {
    if (!_utils_is__WEBPACK_IMPORTED_MODULE_1__/* .isSSR */ .yF) {
      localStorage.setItem(key, value);

      if (value !== storedValue) {
        setStoredValue(value);
      }
    }
  };

  const removeStorage = () => {
    if (!_utils_is__WEBPACK_IMPORTED_MODULE_1__/* .isSSR */ .yF) {
      localStorage.removeItem(key);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const storageValue = localStorage.getItem(key);

    if (storageValue) {
      setStoredValue(storageValue);
    } // eslint-disable-next-line

  }, []);
  return [storedValue, setStorageValue, removeStorage];
}

/* harmony default export */ __webpack_exports__["Z"] = (useStorage);

/***/ }),

/***/ 25890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _checkLogin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23199);




class UserInfoCache {
  constructor() {
    (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "CACHE_KEY", '__user_info_cache__');
  }

  get token() {
    return (0,_checkLogin__WEBPACK_IMPORTED_MODULE_1__/* .getToken */ .LP)();
  }

  resetCache() {
    localStorage.removeItem(this.CACHE_KEY);
  }

  getCache() {
    const str = localStorage.getItem(this.CACHE_KEY);

    if (!str) {
      return null;
    }

    const fn = this.generateCache;
    const cache = JSON.parse(str); // 当前用户 token 与缓存时的 token 不一致，视为缓存失效
    // 取出来的缓存时间戳超过一定时长，视为缓存失效

    if (cache.token !== this.token || dayjs__WEBPACK_IMPORTED_MODULE_0___default().unix(cache.timeStamp).isBefore(dayjs__WEBPACK_IMPORTED_MODULE_0___default()().subtract(3, 'hours'))) {
      this.resetCache();
      return null;
    }

    return cache.userInfo;
  }

  setCache(userInfo) {
    localStorage.setItem(this.CACHE_KEY, JSON.stringify(this.generateCache(userInfo)));
  }

  generateCache(userInfo) {
    return {
      timeStamp: dayjs__WEBPACK_IMPORTED_MODULE_0___default()().unix(),
      token: this.token,
      userInfo
    };
  }

}

/* harmony default export */ __webpack_exports__["Z"] = (new UserInfoCache());

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3220,455,4050,8986,5695,3279,4136,9669,587,6205,3242,7931,1926,4452,5417,6351,1120,5871,236,6611,3097,1954,4347,7634,9509,5287,9,336,9843,8594,1258,5280,9778,7971,1738,9161,4071,3066], function() { return __webpack_exec__(6840), __webpack_exec__(69898); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);